import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PageShell from "../../../components/layout/PageShell";
import PageHead from "../../../components/layout/PageHead";
import Alert from "../../../components/v3/Alert";
import Btn from "../../../components/v3/Btn";
import { useRole } from "../../../hooks/useRole";
import InvestorPaymentAccounts from "../../users/view/InvestorPaymentAccounts";

/**
 * BankAccountReview - one user's bank accounts on the compliance surface
 * (corporate Business PAD contract, Amendment A1).
 *
 * The per-account cards of Viewuser (InvestorPaymentAccounts), bound to the
 * user the answer of GET admin/users/:userId/investor-payment-accounts names,
 * with the proof opened through admin/investor-payment-accounts/:id/proof.
 * Verify / Reject (a note to reject) for DR, CCO and UDP (canDecide); an AD
 * reads only. The page reads no profile: get-user-details-byid refuses a
 * non-AD reading another user, and the answer echoes the user and the legal
 * entity name itself. The cards are keyed by the route's user, so nothing of
 * one user survives on the next user's page.
 */
const USER_ID = /^[1-9]\d*$/;

function BankAccountReview() {
  const navigate = useNavigate();
  const { userId } = useParams();
  const { canDecide } = useRole();
  const valid = USER_ID.test(String(userId ?? ""));

  const headActions = (
    <Btn variant="ghost" size="sm" onClick={() => navigate("/compliance/bank-accounts")}>
      <ChevronLeft /> Back to the queue
    </Btn>
  );

  return (
    <PageShell>
      <PageHead
        title="Company bank accounts"
        subtitle={valid ? <span className="mono">User #{userId}</span> : null}
        actions={headActions}
      />
      {valid ? (
        <section className="card">
          <div className="card__body">
            <InvestorPaymentAccounts key={userId} userId={userId} canDecide={canDecide} />
          </div>
        </section>
      ) : (
        <Alert tone="danger">This address does not name a user id.</Alert>
      )}
    </PageShell>
  );
}

export default BankAccountReview;
